module.exports = __webpack_public_path__ + "img/card-visa.2a982b1d.svg";